import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import bannerImage from "../assets/images/staking-1.svg";
import coinIcon from "../assets/images/steps_1.svg";
import bonusImg1 from "../assets/images/11.png";
import bonusImg2 from "../assets/images/22.png";
import bonusImg3 from "../assets/images/33.png";
import checkIcon from '../assets/images/general.png'
import { useNavigate } from "react-router-dom";

const Affiliate = () => {
    const navigate = useNavigate();

  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />

        <div className="my-16">
          <div className="flex flex-col md:flex-row justify-center lg:justify-evenly sm:items-start gap-10 px-4 py-12 max-w-7xl w-full mx-auto">
            <div className="">
              <h1 className="text-4xl lg:text-8xl font-extrabold leading-tight mb-6">
                JOIN TILLIONX AFFILIATE PROGRAM
              </h1>
              <p className="text-lg mb-6">
                Start earning with the world's <br /> largest crypto exchange!
              </p>
              <button className="bg-yellow-400 text-black font-bold px-6 py-3 rounded-full hover:bg-yellow-300 transition" onClick={() => navigate('/affiliateJoin')}>
                Join Now
              </button>
            </div>
            <div className="relative">
              <img src={bannerImage} alt="Affiliate Program" />
              <img
                src={coinIcon}
                alt="Coin"
                className="absolute -top-6 -left-6"
              />
              <img
                src={coinIcon}
                alt="Coin"
                className="absolute -bottom-6 -right-6"
              />
            </div>
          </div>
          <section className="flex flex-col md:flex-row justify-center items-center gap-12 px-6 py-16 max-w-7xl mx-auto">
            <div className="py-16 px-6 sm:px-20">
              <h2 className="text-3xl sm:text-5xl font-extrabold mb-16 text-center">
                TILLIONX AFFILIATE'S BENEFITS
              </h2>

              <div className="flex flex-col sm:flex-row items-center justify-between gap-10 mb-10">
                <div className="sm:w-1/2">
                  <h3 className="text-xl sm:text-2xl font-bold mb-4">
                    Competitive commission and bonuses
                  </h3>
                  <p className="text-base">
                    Earn up to 50% referral commission on every qualified trade
                    and up to $72,000 in bonuses per month.
                  </p>
                </div>
                <div className="sm:w-1/3 rounded-2xl p-6 flex items-center justify-center">
                  <img
                    src={bonusImg3}
                    alt="Competitive commission"
                    className=""
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-between gap-10">
                <div className="sm:w-1/2">
                  <h3 className="text-xl sm:text-2xl font-bold mb-4">
                    Industry-leading crypto products
                  </h3>
                  <p className="text-base">
                    Generate income across Tillionx Spot, Futures, Margin
                    trading, Tillionx Pool and copy trading products on the
                    world’s number one exchange by trading volume!
                  </p>
                </div>
                <div className="sm:w-1/3 rounded-2xl p-6 flex items-center justify-center">
                  <img src={bonusImg2} alt="Crypto products" className="" />
                </div>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-between gap-10">
                <div className="sm:w-1/2">
                  <h3 className="text-xl sm:text-2xl font-bold mb-4">
                    Affiliate-exclusive campaigns
                  </h3>
                  <p className="text-base">
                    Enjoy exclusive online and offline activations to engage
                    your communities and monetize your content.
                  </p>
                </div>
                <div className="sm:w-1/3 rounded-2xl p-6 flex items-center justify-center">
                  <img src={bonusImg1} alt="Crypto products" className="" />
                </div>
              </div>
            </div>
          </section>
          <section className="flex flex-col md:flex-row justify-center items-center gap-12 px-6 py-16 max-w-7xl mx-auto">
            <div className="bg-[#0B0E11] text-white py-20 px-4 sm:px-12">
             
              <h2 className="text-3xl sm:text-5xl font-extrabold text-center mb-4">
                JOIN TILLIONX AFFILIATE PROGRAM NOW
              </h2>

            
              <p className="text-center text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-8">
                Boost your revenue opportunities and bolster your content with
                the Tillionx Affiliate Program! Get started now!
              </p>

             
              <div className="text-center mb-16">
                <button className="bg-[#fcd535] text-black font-semibold rounded-full px-8 py-3 text-lg hover:opacity-90 transition" onClick={() => navigate('/affiliateJoin')}>
                  Join now
                </button>
              </div>

              
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-6xl mx-auto">
              
                <div className="border border-gray-700 rounded-2xl p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <img src={checkIcon} alt="Step 1" className="w-10 h-10" />
                  </div>
                  <h3 className="text-[#fcd535] text-lg font-bold mb-1">
                    Step 1
                  </h3>
                  <h4 className="font-semibold mb-2">
                    Sign up to become an affiliate
                  </h4>
                  <p className="text-sm text-gray-400">
                    Submit your application by filling the form below. Our team
                    will evaluate your application and ensure you meet our
                    affiliate criteria.
                  </p>
                </div>

               
                <div className="border border-gray-700 rounded-2xl p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <img src={checkIcon} alt="Step 2" className="w-10 h-10" />
                  </div>
                  <h3 className="text-[#fcd535] text-lg font-bold mb-1">
                    Step 2
                  </h3>
                  <h4 className="font-semibold mb-2">
                    Create and share your affiliate link
                  </h4>
                  <p className="text-sm text-gray-400">
                    Create, manage and track the performance of your affiliate
                    links right from your Tillionx account.
                  </p>
                </div>

                
                <div className="border border-gray-700 rounded-2xl p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <img src={checkIcon} alt="Step 3" className="w-10 h-10" />
                  </div>
                  <h3 className="text-[#fcd535] text-lg font-bold mb-1">
                    Step 3
                  </h3>
                  <h4 className="font-semibold mb-2">
                    Earn up to 50% commissions
                  </h4>
                  <p className="text-sm text-gray-400">
                    When users create an account with your affiliate link,
                    you’ll receive commission on every trade they make.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Affiliate;
